import React from "react"
import { useSelector } from "react-redux"
import { AppState } from "store/store"
import styles from "./CommonStepBar.module.scss"

export interface CommonStepBarProps {
  num: number
}
/**
 * Step1〜Step5表すステップバー部品
 * @param {number} num - 1〜5（Step）の値を設定
 */
const CommonStepBar = ({ num }: CommonStepBarProps) => {
  const cameraOff = useSelector((state: AppState) => state.cameraOff.cameraOff)
  // カメラ機能無し版の場合、矢羽で表示している進捗番号をマイナス1とする
  // 0になったら、1にする
  const adjustedNum = cameraOff ? Math.max(1, num - 1) : num
  let maxSteps = 6
  if (cameraOff) maxSteps -= 1

  const listWrapper = (liClassNames: any, divClassNames: any, i: number) => {
    return (
      <li className={liClassNames} key={i}>
        <div className={divClassNames}>{i}</div>
      </li>
    )
  }

  const listCounter = () => {
    const items = []
    const liPrev = `${styles.stepbar__item}`
    const liCurrent = `${styles.stepbar__item}`
    const liNext = `${styles.stepbar__item__next}`
    const divPrev = `${styles.stepbar__item_inner}`
    const divCurrent = `${styles.stepbar__item_inner} ${styles.stepbar__item_inner__current}`
    const divNext = `${styles.stepbar__item_inner} ${styles.stepbar__item_inner__next}`
    for (let i = 1; i < maxSteps; i += 1) {
      if (i < adjustedNum) {
        items.push(listWrapper(liPrev, divPrev, i))
      } else if (i === adjustedNum) {
        items.push(listWrapper(liCurrent, divCurrent, i))
      } else {
        items.push(listWrapper(liNext, divNext, i))
      }
    }
    return <ul className={styles.stepbar}>{items}</ul>
  }
  return listCounter()
}

export default CommonStepBar
